<div class="toll">
  <div class="toll-header">
    <app-header></app-header>
  </div>
  <div class="toll-body">
    <router-outlet></router-outlet>
    <app-loader-spinner></app-loader-spinner>
  </div>
  <div class="toll-footer">
    <app-genesys-chat></app-genesys-chat>
    <app-footer [disableButton]="true"></app-footer>
  </div>
</div>
